//
// must match EnumDbRole
//
export const OWNER = 'owner';
export const ADMIN = 'admin';
export const SUPER_ADMIN = 'superAdmin';
export const COLLABORATOR = 'collaborator';
